<div class="rail-top">
  <button type="button" class="new-chat" (click)="newChat.emit()">
    <mat-icon>add</mat-icon>{{ 'New chat' | translate }}
  </button>
</div>
<div class="search">
  <mat-icon class="search-icon">search</mat-icon>
  <input type="text" #searchInput [placeholder]="'Search chats…' | translate" (input)="onSearchInput(searchInput.value)">
  @if (searchTerm) {
    <button type="button" class="search-clear" (click)="clearSearch(searchInput)">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
<div class="hist">
  @if (chats.length === 0) {
    <div class="hist-empty">
      <mat-icon>forum</mat-icon>
      <p>{{ 'No chats yet' | translate }}</p>
      <span>{{ 'Start a new chat to see your history here.' | translate }}</span>
    </div>
  }
  @if (chats.length > 0 && groups.length === 0) {
    <div class="hist-empty">
      <mat-icon>search_off</mat-icon>
      <p>{{ 'No chats found' | translate }}</p>
      <span>{{ 'Try a different search term.' | translate }}</span>
    </div>
  }
  @for (group of groups; track trackByGroupName($index, group)) {
    <div class="hist-group" [class.starred]="group.name === 'Starred'">
      @if (group.name === 'Starred') {
        <mat-icon>star</mat-icon>
        }{{ group.name | translate }}
      </div>
      @for (row of group.rows; track trackByRowId($index, row)) {
        <div class="hrow" [class.active]="row.chat.id === activeChatId"
          [class.row-enter]="row.chat.id === newlyAddedChatId" (click)="selectChat(row.chat)">
          @if (row.chat.isStarred) {
            <mat-icon class="star-badge">star</mat-icon>
          }
          <div class="htext" [attr.data-full-title]="renamingChatId === row.chat.id ? null : row.chat.title">
            @if (renamingChatId === row.chat.id) {
              <input type="text" class="rename-input" #renameField [maxLength]="renameMaxLength"
                (click)="$event.stopPropagation()" (input)="onRenameInput($event)" (blur)="commitRename(row.chat)" (keyup.enter)="commitRename(row.chat)"
                (keydown.escape)="cancelRenaming()">
              } @else {
                <div class="htitle">{{ row.chat.title }}</div>
              }
              <div class="htime">
                @if (row.timeLabel.type === 'translated') {
                  {{ row.timeLabel.key | translate: row.timeLabel.params }}
                } @else {
                  {{ row.timeLabel.date | dateFormat }}
                }
              </div>
            </div>
            <button type="button" class="kebab-btn" [matMenuTriggerFor]="rowMenu" #menuTrigger="matMenuTrigger"
              [matTooltip]="'More actions' | translate" (click)="$event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu" class="rail-menu" xPosition="before">
              <button mat-menu-item (click)="startRenaming(row.chat, $event, menuTrigger)">
                <mat-icon>edit</mat-icon><span>{{ 'Rename' | translate }}</span>
              </button>
              <button mat-menu-item class="star-item" [class.is-starred]="row.chat.isStarred"
                (click)="toggleStar(row.chat, $event)">
                <mat-icon>{{ row.chat.isStarred ? 'star' : 'star_border' }}</mat-icon>
                <span>{{ (row.chat.isStarred ? 'Unstar' : 'Star') | translate }}</span>
              </button>
              <button mat-menu-item class="danger-item" (click)="requestDelete(row.chat, $event)">
                <mat-icon>delete_outline</mat-icon><span>{{ 'Delete' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        }
      }
    </div>
